function isIE() {
  if (typeof window === 'undefined') {
    return false;
  }
  var userAgent = window.navigator.userAgent;
  return /Trident\/|MSIE/.test(userAgent);
}

export { isIE };
